import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-travels-dashboard',
  templateUrl: './travels-dashboard.component.html',
  styleUrls: ['./travels-dashboard.component.scss']
})
export class TravelsDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
